// Custom override: Add variants.sku to predictive search fields
// Keeps SKU search working in the search drawer even after theme updates

(function () {
  function patchPredictiveSearch() {
    const element = customElements.get('predictive-search');
    if (!element) {
      // Web component not registered yet – try again shortly
      return false;
    }

    const original = element.prototype._doPredictiveSearch;
    if (!original || element.prototype._skuPatched) return true;

    element.prototype._doPredictiveSearch = async function () {
      await this._transitionToSlot('loading');

      const fields = 'title,product_type,variants.title,vendor,variants.sku';
      const queryParams =
        `q=${encodeURIComponent(this._queryInput.value)}` +
        `&section_id=${this.getAttribute('section-id')}` +
        `&resources[limit]=10&resources[limit_scope]=each` +
        `&resources[options][fields]=${fields}`;

      const response = await fetch(
        `${window.Shopify.routes.root}search/suggest?${queryParams}`,
        { signal: this._abortController.signal }
      );
      const html = await response.text();
      const nodeElement = new DOMParser().parseFromString(html, 'text/html');

      this.querySelector('[slot="results"]').replaceWith(
        document.importNode(nodeElement.querySelector('[slot="results"]'), true)
      );
      return this._transitionToSlot('results');
    };

    element.prototype._skuPatched = true;
    return true;
  }

  // Try immediately, then keep trying until the component is defined
  if (!patchPredictiveSearch()) {
    const interval = setInterval(() => {
      if (patchPredictiveSearch()) clearInterval(interval);
    }, 50);
    // Give up after 10 seconds to avoid runaway
    setTimeout(() => clearInterval(interval), 10000);
  }
})();